import { List } from "immutable";
import { createSelector } from "reselect";

import Dimensions from "../../constants/styles/dimensions";
import { appStateSelectors } from "../../modules/appState";
import { immutableRecords } from "../../types";
import userAgent from "../../utils/userAgent";

const getShowLeftPanel = state => Boolean(appStateSelectors.getLeftPanelMode(state));

const getWelcomeSplitConstraints = createSelector(
  // inputs
  showAppMenu => showAppMenu,
  // calculate based on inputs
  showAppMenu => {
    const TOOLBAR_HEIGHT = Dimensions.TOOLBAR_HEIGHT;

    let constraints = showAppMenu
      ? List([
        // App Menu
        immutableRecords.SplitConstraintsRecord({
          minSize: Dimensions.APP_TITLE_BAR_HEIGHT,
          maxSize: Dimensions.APP_TITLE_BAR_HEIGHT,
          preferredSize: Dimensions.APP_TITLE_BAR_HEIGHT
        }),
        // Toolbar
        immutableRecords.SplitConstraintsRecord({
          minSize: TOOLBAR_HEIGHT,
          maxSize: TOOLBAR_HEIGHT,
          preferredSize: TOOLBAR_HEIGHT
        }),
        // Everything else
        immutableRecords.SplitConstraintsRecord({
          minSize: 200
        })
      ])
      : List([
        // Toolbar
        immutableRecords.SplitConstraintsRecord({
          minSize: TOOLBAR_HEIGHT,
          maxSize: TOOLBAR_HEIGHT,
          preferredSize: TOOLBAR_HEIGHT
        }),
        // Everything else
        immutableRecords.SplitConstraintsRecord({
          minSize: 200
        })
      ]);

    //#!if harvard === true
    constraints = List([
      immutableRecords.SplitConstraintsRecord({
        minSize: 200
      })
    ]);
    //#!endif

    return constraints;
  }
);

const getWorkSplitConstraints = createSelector(
  // inputs
  getShowLeftPanel,
  appStateSelectors.getShowRightPanel,
  appStateSelectors.getLeftPanelWidth,
  appStateSelectors.getRightPanelWidth,
  (_state, windowWidth) => windowWidth,
  // calculate based on inputs
  // We are going to use the showInspectorPanel
  // when the split view size control has been
  // fixed.
  (showLeftPanel, showInspectorPanel, leftPanelWidth, rightPanelWidth, windowWidth) => {
    const maxLeftWidth = Math.max(Dimensions.MAX_LEFT_PANEL_WIDTH, Math.ceil(windowWidth / 3));
    const maxRightWidth = Math.max(Dimensions.MAX_RIGHT_PANEL_WIDTH, Math.ceil(windowWidth / 3));
    return List([
      // Left Panel
      immutableRecords.SplitConstraintsRecord({
        minSize: showLeftPanel ? Dimensions.MIN_LEFT_PANEL_WIDTH : Dimensions.COLLAPSED_LEFT_PANEL_WIDTH,
        maxSize: showLeftPanel ? maxLeftWidth : Dimensions.COLLAPSED_LEFT_PANEL_WIDTH,
        preferredSize: showLeftPanel
          ? leftPanelWidth
            ? leftPanelWidth
            : Dimensions.DEFAULT_LEFT_PANEL_WIDTH
          : Dimensions.COLLAPSED_LEFT_PANEL_WIDTH,
        hasDivider: showLeftPanel,
        canResize: showLeftPanel,
        canCollapse: false
      }),
      // Main Area
      immutableRecords.SplitConstraintsRecord({
        minSize: 200,
        hasDivider: true,
        canResize: true,
        dividerVisible: !showInspectorPanel
      }),
      //#!if readonly !== true
      // Inspector
// immutableRecords.SplitConstraintsRecord({
// minSize: Dimensions.MIN_RIGHT_PANEL_WIDTH,
// maxSize: maxRightWidth,
// preferredSize: showInspectorPanel
// ? rightPanelWidth
// ? rightPanelWidth
// : Dimensions.DEFAULT_RIGHT_PANEL_WIDTH
// : Dimensions.COLLAPSED_RIGHT_PANEL_WIDTH,
// collapseSize: Dimensions.COLLAPSED_RIGHT_PANEL_WIDTH,
// canCollapse: true
// })
      //#!endif
    ]);
  }
);

const getShowAppMenu = () => {
  let showAppMenu = userAgent.isWindowsApp() || userAgent.isUnknownApp();
  //#!if harvard === true
  showAppMenu = false;
  //#!endif
  return showAppMenu;
};

//#!if harvard === true
const getHarvardMobileSplitConstraints = () =>
  List([
    // Toolbar
    immutableRecords.SplitConstraintsRecord({
      minSize: Dimensions.TOOLBAR_HEIGHT,
      maxSize: Dimensions.TOOLBAR_HEIGHT,
      preferredSize: Dimensions.TOOLBAR_HEIGHT
    }),
    // Main View
    immutableRecords.SplitConstraintsRecord({
      minSize: 200
    })
  ]);
//#!endif

export default {
  getWelcomeSplitConstraints,
  getWorkSplitConstraints,
  getShowAppMenu,
  getShowLeftPanel,
  //#!if harvard === true
  getHarvardMobileSplitConstraints
  //#!endif
};
